import HttpUtils from '../utils/HttpUtils';
import {getFilters} from "../utils/browserUtils";

const baseUrl = process.env.REACT_APP_BASE_API;


async function getUserList(params = {}){
    const { page = 1, pageSize = 10 } = params;
    const response = await HttpUtils.sendRequest(baseUrl,'aop_get_user_list', { params: { page, pageSize } });
    return response;
  };

async function createUser(params){
    const response = await HttpUtils.sendRequest(baseUrl,'aop_create_user', { 
      params: { 
        address: params.address 
      } 
    });
    return response;
  };

async function userLogin(params){
    console.log("process.env.NODE_ENV:"+process.env.NODE_ENV+" ===> baseUrl:"+baseUrl)
    return await HttpUtils.sendRequest(baseUrl, "aop_login", params)
  }

async function userLogout(params){
    const tokenStr = getFilters("token");
    let token = null;
    try {
        token = tokenStr ? JSON.parse(tokenStr) : null;
    } catch (e) {
        console.error('Error parsing token:', e);
    }
    return await HttpUtils.sendRequest(baseUrl, "aop_logout", params, token);
  }

async function checkUserTokenExist(params){

    return await HttpUtils.sendRequest(baseUrl, "aop_check_user_token", params, undefined);
  }


const UserServiceApi = {
    getUserList,
    createUser,
    userLogin,
    userLogout,
    checkUserTokenExist,
};

export default UserServiceApi;
